import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import CoreStyles from '../core/Styles';
import {LabelSmallText} from '../core/Type';
import Glyph from '../core/Glyph';

export default class ComboBox extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            comboBox: {
                height: CoreMetrics.ElementHeight.Small(),
                display: "flex",
                alignItems: "center",
                justifyItems: "stretch",
                backgroundColor: CoreMetrics.Color.LightUI.PrimaryBG,
                borderRadius: CoreMetrics.CornerRadius,
                outline: "none",
                paddingTop: 0,
                paddingLeft: CoreMetrics.ElementPadding.Medium(),
                paddingRight: CoreMetrics.ElementPadding.Medium(),
            },
            dropdown: {
                marginLeft: CoreMetrics.ElementPadding.XXSmall(),
            },
        });

        const {placeholder} = this.props;
        return (
            <div className={css(styles.comboBox, CoreStyles.hairlineOuterStroke)}>
                <LabelSmallText styles={[CoreStyles.PlaceholderText]}>{placeholder}</LabelSmallText>
                <Glyph styles={[styles.dropdown]} asset="assets/12x12-dropdown.svg" size={Glyph.Size.XSmall} fillColor={CoreMetrics.Color.Neutral.OffBlack} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/controls/ComboBox.jsx